module.exports = __webpack_public_path__ + "media/img/star-77719391cee11179cf8f87c58582259f.png";